import type { TrainingLessonSpecific } from './trainingLessonUi';

export const core2PlanOfSalvationEn: TrainingLessonSpecific = {
  intro:
    'The plan of salvation explains our origin, purpose on earth, and eternal destiny. In this lesson you will explore its foundations and how it guides you each day.',
  objectives: [
    'Understand the three degrees of glory and the purpose of mortal life',
    "Identify the Savior's role in the plan of salvation",
    'Recognize the importance of agency and the consequences of our choices',
    'Reflect on how the plan gives you purpose and hope',
    'Apply principles of the plan in daily decisions',
  ],
  briefHeading: 'The plan in brief',
  briefBody:
    'We lived with Heavenly Father before birth. We came to earth to receive a body, be tested, and progress. Through the Savior we can repent, be forgiven, and return to God’s presence. Our agency lets us choose the path we follow.',
  scriptures: [
    {
      ref: '2 Nephi 2:25',
      text: 'Adam fell that men might be; and men are, that they might have joy.',
    },
    {
      ref: 'Alma 34:32',
      text: 'For behold, this life is the time for men to prepare to meet God; yea, behold the day of this life is the day for men to perform their labors.',
    },
    {
      ref: 'Moses 1:39',
      text: 'For behold, this is my work and my glory—to bring to pass the immortality and eternal life of man.',
    },
    {
      ref: '2 Nephi 2:27',
      text: 'Wherefore, men are free according to the flesh… to choose eternal life… or to choose captivity and death.',
    },
    {
      ref: 'Doctrine and Covenants 76:22',
      text: 'And now, after the many testimonies which have been given of him, this is the testimony… that he lives!',
    },
  ],
  didYouKnow: [
    'The phrase “plan of salvation” appears in the Book of Mormon (Alma 42:5) and in the Doctrine and Covenants, showing it is central to the Restoration.',
    'The three degrees of glory were revealed to Joseph Smith in 1832 (D&C 76), reflecting God’s mercy toward all His children.',
  ],
  practiceItems: [
    'Read 2 Nephi 2',
    'Ponder Alma 34:32 and what “prepare” means for you',
    'Identify a recent choice where you exercised agency',
    'Write a prayer of gratitude for the plan of salvation',
    'Share with someone what gives you hope from the plan',
  ],
  reflectionQuestions: [
    'How does the plan of salvation help you make sense of trials?',
    'How has agency helped you draw closer to the Savior?',
    'Which part of the plan (premortal, mortal, postmortal) feels most meaningful right now?',
  ],
  actionText:
    'In prayer, thank Heavenly Father for the plan of salvation and ask for guidance about a decision you are facing.',
};
